export default __webpack_public_path__ + "static/media/ic-camera-permission.fd402aa8.svg";